<template>
  <div class="is-flex">
    <div
      v-if="showHeader"
      :style="{
        width: `${isShrink ? '100%' : `${widthColumnNavProps + 9}px`}`,
        height: `${heightColumnWeeklyProps}px`,
        minWidth: `${minWidthSideColumn}px`
      }"
      class="sticky-left z-index-2 total-weekly-column side p-3 flex-center-vertical px-3"
      :class="{ 'adjust-content-shrink': isShrink && fromCollapse, 'adjust-border': fromCollapse }"
    >
      <p class="averta-bold has-text-centered" :class="[isShrink ? 'label-18' : 'label-14']">
        Total Mingguan :
        <span class="averta-black label-16">{{ countValueInsideArray(totalWeekProps) }}</span>
      </p>
      <!-- <p class="label-14">({{ countValueInsideArray(totalWeekProps) }})</p> -->
    </div>
    <div
      v-if="showColumn"
      class="is-flex"
      :class="{
        'c-w-100': isShrink,
        'flex-1 min-c-w-0': isShrink && fromCollapse
      }"
    >
      <div
        v-for="(weekly, index) in totalWeekProps"
        :key="`empty-${index}`"
        :style="{
          width: `${widthColumnProps}px`,
          height: `${heightColumnWeeklyProps}px`
        }"
        :class="{ 'border-right-5': index === 1, 'flex-1': isShrink }"
        class="total-weekly-column flex-center is-flex-direction-column"
      >
        <div
          v-if="index === 'hide-idx-before-is-13'"
          class="flex-center-vertical is-justify-content-space-between c-w-100 px-2"
          :class="{ 'is-flex-direction-column': isShrink }"
        >
          <div
            class="mr-2 pr-2 flex-1"
            :class="{
              'border-right-1-grey-13': !isShrink
            }"
          >
            <p class="averta-bold white-space-nowrap">
              Baru: {{ weekly.first_day_completed || 0 }}/{{ weekly.first_day_not_completed || 0 }}
            </p>
          </div>
          <div v-if="isShrink" class="divider-line horizontal"></div>
          <div class="mr-2 pr-2 flex-1">
            <p class="averta-bold white-space-nowrap">
              Lanjutan: {{ weekly.existing_day_completed || 0 }}/{{
                weekly.existing_day_not_completed || 0
              }}
            </p>
          </div>
        </div>

        <!-- <div
          v-else
          class="flex-center"
          :class="{ 'is-flex-direction-column': isToday || index === 13 }"
        >
          <p class="averta-bold label-14 mr-1">
            Sudah : {{ weekly.completed }}
            <span v-if="isToday || index === 13">
              <span class="label-16">|</span> {{ index === 17 ? 'Total Telat' : 'Belum' }} :
              {{ index === 17 ? weekly.late : weekly.not_completed }}
            </span>
          </p>
          <p v-if="index === 6 || index === 7" class="averta-bold label-14">
            <span v-if="!(isToday || index === 13)" class="label-16">|</span> Revisi :
            {{ weekly.revised }}
          </p>
        </div> -->

        <div
          v-else
          class="averta-bold label-14 is-flex is-align-items-center"
          :class="{ '': isShrink }"
        >
          <p :class="{ 'label-18': isShrink }">
            {{ isShrink ? 'S' : 'Sudah' }} :
            <span class="color-progress-done">{{ weekly.completed }}</span>
          </p>
          <p v-if="isToday" :class="{ 'label-18': isShrink }">
            <span class="color-grey-16 ml-1">|</span> {{ isShrink ? 'B' : 'Belum' }} :
            <span class="color-progress-not-yet">{{ weekly.not_completed }}</span>
          </p>
          <div v-if="isToday && showRevisi(index)" class="flex-center">
            <div class="divider-line"></div>
            <p :class="{ 'label-18': isShrink }">
              {{ isShrink ? 'R' : 'Revisi' }} :
              <span class="color-progress-revision">{{ weekly.revised }}</span>
            </p>
          </div>
          <!-- <p>Sudah : {{ weekly.completed }}</p>
          <div v-if="isToday" class="divider-line" :class="{ 'horizontal': isShrink }"></div>
          <p v-if="isToday || index === 13">
            Belum :
            {{ index === 17 ? weekly.late : weekly.not_completed }}
          </p> -->
        </div>
        <!-- <div v-if="isShrink && (index === 6 || index === 7)">
          <div class="divider-line horizontal"></div>
          <p class="averta-bold label-14 has-text-centered">
            <span v-if="!(isToday || index === 13)" class="label-16">|</span>
            Revisi : {{ weekly.revised }}
          </p>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TotalWeeklyColumnProgress',
  props: {
    showHeader: {
      type: Boolean,
      default: false
    },
    showColumn: {
      type: Boolean,
      default: true
    },
    fromCollapse: {
      type: Boolean,
      default: false
    },
    totalWeekProps: {
      type: Array
    },
    heightColumnWeeklyProps: {
      type: Number
    },
    widthColumnProps: {
      type: Number
    },
    widthColumnNavProps: {
      type: Number
    },
    isToday: {
      type: Boolean
    },
    scaleTableProps: {
      type: Number
    },
    minWidthSideColumn: {
      type: Number
    }
  },
  computed: {
    isShrink () {
      return this.scaleTableProps < 0.6
    }
  },
  methods: {
    countValueInsideArray (arrayDaily) {
      if (!arrayDaily || arrayDaily.length < 1) {
        return 0
      }

      let total = 0
      for (let i = 0; i < arrayDaily.length; i++) {
        total += arrayDaily[i].completed
      }

      return total
    },
    showRevisi (index) {
      return index === 6 || index === 7
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/scss/_variables.scss';

.total-weekly-column {
  border: 1px solid $color-grey-10;
  border-top-width: 0;
  border-bottom-width: 0;
  border-left-width: 0;
  background: $color-light-green-2;
  // background: #1ad762;
  // color: white;

  &.side {
    // border-left-width: 1px;
    border-right-width: 0;
  }

  &.adjust-content-shrink {
    flex: 0 0 7%;
  }

  &.adjust-border {
    border-right: 5px solid $color-grey-10;
  }
}

.divider-line {
  width: 2.2px;
  height: 16px;
  background-color: #cbd5e1;
  transition: all 0.3s ease-in-out;
  margin: 0 4px;
}

.divider-line.horizontal {
  width: 125px;
  height: 1px;
  margin: 3px 0;
}
</style>
